import { useEffect, useState } from 'react';

/**
 * Geeft de huidige online/offline status van de browser terug en houdt deze up-to-date via de
 * standaard `online`/`offline`-events op `window`. Wordt gebruikt om een overlay te tonen bij
 * connectiviteitsverlies (`InternetConnectionStatus`). Let op: dit reflecteert alleen de
 * netwerkverbinding van de browser zelf, niet de bereikbaarheid van de backend — het legen van de
 * wachtrij met logmeldingen (`useFrontendLogger`) gebeurt via een eigen interval, niet via deze hook.
 */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState<boolean>(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return online;
}
